var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListBoxes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.002,
    height: 16.287,
    viewBox: "0 0 19.002 16.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20",
    d: "M18 9h9.5v1.357H18z",
    transform: "translate(-8.499 -6.285)",
    style: {
      fill: "#6f52f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M18 24.75h9.5v1.357H18z",
    transform: "translate(-8.499 -12.535)",
    style: {
      fill: "#6f52f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M7.679 11.286H3.607A1.358 1.358 0 0 1 2.25 9.929V5.857A1.358 1.358 0 0 1 3.607 4.5h4.072a1.358 1.358 0 0 1 1.357 1.357v4.072a1.358 1.358 0 0 1-1.357 1.357zM3.607 5.857v4.072H7.68V5.857z",
    style: {
      fill: "#6f52f7"
    },
    transform: "translate(-2.25 -4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "M7.679 27.036H3.607a1.358 1.358 0 0 1-1.357-1.357v-4.072a1.358 1.358 0 0 1 1.357-1.357h4.072a1.358 1.358 0 0 1 1.357 1.357v4.072a1.358 1.358 0 0 1-1.357 1.357zm-4.072-5.429v4.072H7.68v-4.072z",
    transform: "translate(-2.25 -10.749)",
    style: {
      fill: "#6f52f7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBoxes);
export default __webpack_public_path__ + "static/media/list-boxes.c1470ae949a1f030278ce7dc0add8bd3.svg";
export { ForwardRef as ReactComponent };